import React from "react";
import { Box, Typography, Modal } from "@mui/material";
import "./style.css";
import Spinner from "../../assets/images/Spinner.png";
import useTranslation from "../../hooks/translations";

const keyframes = `
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

interface PaymentProcessingModalProps {
  amount: number;
  isOpen: boolean;
  onClose: any;
  providerId: string;
}

type ProcessingHintValue = React.ReactNode;
type ProcessingHints = {
  [key: string]: ProcessingHintValue;
};

const PaymentProcessingModal: React.FC<PaymentProcessingModalProps> = ({
  amount,
  isOpen,
  onClose,
  providerId,
}) => {
  const { t, translationObject } = useTranslation();

  const precessingHint: ProcessingHints = {
    u123a1b8490a4ea1335eed85a799a6fb: (
      <>
        {translationObject.formatString(
          t("dialToApprove"),
          <span style={{ color: "#0AA5B7", fontWeight: 600 }}>*126#</span>
        )}
      </>
    ),
    b166771794fa2b1099212d5ff107e22a: (
      <>
        {translationObject.formatString(
          t("dialToApprove"),
          <span style={{ color: "#0AA5B7", fontWeight: 600 }}>#150*50#</span>
        )}
      </>
    ),
    o911y2q8hg0a4ea19o52ed15h552a6hq: <>{t("yooMeeHint")}</>,
    n123m1b8490a4ea1335eed85b799a6fb: <>{t("expressUnionHint")}</>,
  };

  return (
    <Modal
      open={isOpen}
      onClose={(e, reason) => onClose(e, reason)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className={"box"}>
        <Box className={"imageBox"}>
          <style>{keyframes}</style>
          <img src={Spinner} alt="processing" className={"spinnerStyle"} />
        </Box>
        <Typography
          variant="h4"
          component="h2"
          gutterBottom
          className={"centerText"}
        >
          {t("awaitingPayment")}
        </Typography>
        <Typography
          variant="body1"
          component="p"
          gutterBottom
          sx={{ color: "#667085" }}
          className={"centerText"}
        >
          {t("notififcationToWithdraw")}
        </Typography>
        <Typography
          variant="h4"
          component="h2"
          gutterBottom
          sx={{ fontWeight: 500 }}
          className={"centerText"}
        >
          {amount} FCFA
        </Typography>
        <Typography
          variant="body1"
          component="p"
          gutterBottom
          sx={{ marginTop: 2 }}
          className={"centerText"}
        >
          {precessingHint[providerId]}
        </Typography>
      </Box>
    </Modal>
  );
};

export default PaymentProcessingModal;
